import Nullstack from 'nullstack';
export default function IconGasStationOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-gas-station-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M15 11a2 2 0 0 1 2 2m3 3v-7l-3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M4 20v-14c0 -.548 .22 -1.044 .577 -1.405m3.423 -.595h4a2 2 0 0 1 2 2v4m0 4v6"
  }), "   ", Nullstack.element("path", {
    d: "M3 20h12"
  }), "   ", Nullstack.element("path", {
    d: "M18 7v1a1 1 0 0 0 1 1h1"
  }), "   ", Nullstack.element("path", {
    d: "M4 11h7"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}